import './FileViewerModal.scss';
import React, { useCallback, useState } from 'react';
import clsx from 'clsx';
import { IDocument } from '@cyntler/react-doc-viewer/dist/models';
import Modal from '@atoms/Modal';
import { ModalSize } from '@/types/ModalSize';
import FileViewer from '@molecules/FileViewer';
import DOMPurify from 'dompurify';
import Hint from '@atoms/Hint';
import { useLocalStorage } from 'usehooks-ts';
import { useTypedSelector } from '@hooks/useTypedSelector';

export interface IFileViewerModalProps {
    /** Файлы */
    docs: IDocument[];
    /** Размер модального окна */
    modalSize: ModalSize;
    /** Колбэк закрытия окна */
    onClose: () => void;
}

const InitialActiveDocumentNumber = 0;

const FileViewerModal = ({ docs, ...props }: IFileViewerModalProps) => {
    const [activeDocument, setActiveDocument] = useState<IDocument>(docs[InitialActiveDocumentNumber]);

    const currentUser = useTypedSelector((state) => state.auth.user);

    const [hintDismissed, setHintDismissed] = useLocalStorage<boolean>(
        `user-${currentUser.username}.fileViewerModalHint`,
        false,
    );

    const modalHeader = (
        <div className={clsx('file-viewer-modal__header')}>
            <div className={clsx('file-viewer-modal__header-text')}>
                <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(activeDocument.fileName ?? '') }}></span>
            </div>
        </div>
    );

    const onDocumentChange = useCallback((document: IDocument) => {
        setActiveDocument(document);
    }, []);

    return (
        <Modal
            className={clsx('file-viewer-modal')}
            size={props.modalSize}
            header={modalHeader}
            onClose={() => {
                props.onClose();
            }}
            closeOnEscape={true}
        >
            {!hintDismissed && (
                <div className="file-viewer-modal__hint">
                    <Hint
                        title="Отображение файлов в режиме предпросмотра может отличаться от их оригинального вида. Для точного отображения рекомендуем скачать файл."
                        onClose={() => {
                            setHintDismissed(true);
                        }}
                        variant="blue"
                        maxWidth="100%"
                    />
                </div>
            )}
            <FileViewer
                docs={docs}
                initialActiveDocumentNumber={InitialActiveDocumentNumber}
                onDocumentChange={onDocumentChange}
            />
        </Modal>
    );
};

export default FileViewerModal;
